module.exports = __webpack_public_path__ + "static/media/pacientes.99209418.png";